/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'

export default function TemplateList({
  templateList = [],
  icon = '',
  headerTitle = '',
  type = '',
  testid = '',
  isStarred = false,
}) {
  if (templateList.length === 0) {
    return null
  }

  return (
    <div className={isStarred ? 'mb-3' : null} data-testid={testid}>
      <h6 className="dropdown-header p-2" data-testid={`${testid}Title`}>
        <i className={`fa ${icon}`} />
        <span>{headerTitle}</span>
      </h6>
      <div className="dropdown-divider"></div>
      <div className="dropdown-items-container">
        {templateList.map((template) => {
          return (
            <a
              className="dropdown-item p-2"
              id={`${type}-template-${template.id}`}
              key={template.id}
              href="#"
              onClick={() => {
                window.location.href = template.href
              }}
            >
              {template.name}
            </a>
          )
        })}
      </div>
      {!isStarred && <div className="dropdown-divider"></div>}
    </div>
  )
}
